import React from 'react';
import './LegalPage.css';
import Pricing from "../components/Pricing";

const SolucionesPersonalizadas = () => (
    <div className="legal-page">
        <h1>Soluciones Personalizadas</h1>
        <h2>"Tú tienes la idea, nosotros la convertimos en una solución de voz"</h2>
        <p>Sabemos que cada empresa es única, por eso desarrollamos agentes personalizados que se adaptan 100% a tus necesidades. Desde procesos financieros hasta control de acceso o gestión de reservas inusuales, diseñamos lo que necesites.</p>
        <h3>¿Qué hacemos aquí?</h3>
        <ul>
            <li>Escuchamos tu necesidad o flujo actual</li>
            <li>Diseñamos un agente que se adapte a tu lógica de negocio</li>
            <li>Lo entrenamos con tus datos y ajustamos su comportamiento según tus reglas</li>
        </ul>
        <h3>Enfoque 100% personalizado:</h3>
        <p>Voz, idioma, tono, integración, visualización, tipo de datos, respuestas, acciones, etc.</p>
        <h3>Ejemplo real:</h3>
        <p>Un despacho de abogados solicita un asistente que gestione sus citas, registre la naturaleza del caso y sugiera el abogado más adecuado según palabras clave, todo desde una llamada de voz automatizada.</p>
        <Pricing/>
    </div>
);
export default SolucionesPersonalizadas;
